import { SMITHY_CONTEXT_KEY } from "@smithy/types";
export const getSmithyContext = (context) => context[SMITHY_CONTEXT_KEY] || (context[SMITHY_CONTEXT_KEY] = {});
